<div class="section-margin">
    <div class="rows">
        <div class="row">
            <div class="row10">
                <div class="col-md-12">
                    <div id="chartdiv" style="max-height:400px;"></div>
                </div>
            </div>
        </div>
        <div *ngIf="chartDataReesponse?.length === 0" class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
        </div>
    </div>
</div>
